import { render, staticRenderFns } from "./UserQualificationCards.vue?vue&type=template&id=4485faaf&"
import script from "./UserQualificationCards.vue?vue&type=script&lang=js&"
export * from "./UserQualificationCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports